import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';

interface DeleteClipGroupParams {
  playbyplayId: string;
  clipGroupId: number;
}

const useDeleteClipGroupMutation = () => {
  const queryClient = useQueryClient();
  const gameId = useCurrentGameId();

  return useMutation({
    mutationFn: async ({ playbyplayId, clipGroupId }: DeleteClipGroupParams) => {
      const response = await del<{ success: boolean; message: string }>(
        `/v1.0/games/${gameId}/play-by-play/${playbyplayId}/clip-groups/${clipGroupId}`
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      // Invalidate the clip groups query for this play-by-play event
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'PlayByPlay', variables.playbyplayId, 'ClipGroups']
      });
      // Also invalidate game-level clip groups
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'ClipGroups']
      });
      // Invalidate clips query since clips in the group were deleted
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'Clips']
      });
      // Invalidate clip group counts to update event action icons
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'ClipGroupCounts']
      });
    },
  });
};

export default useDeleteClipGroupMutation;
